import { vuexHandbook } from '@/store/composition/handbook'
import { TestApi } from '@/api/handbook/position/Test/TestApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: TestApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
